import * as React from "react";

import InlineMessage from "@ingka/inline-message";

import useStore, { activeMarketSelector, applicationsLoadingSelector, marketsLoadingSelector } from "../../store";
import ConfigurationViewer from "../ConfigurationViewer";
import { HomePageLayoutTabs } from "../../utils/constants";
import { LoadingWrapper } from "../styles";
import useTabs from "../../hooks/useTabs";
import { LoadingComponent } from "../LoadingLayout";
import useLoadingAnnouncer from "../LoadingAnnouncer/useLoadingAnnouncer";
import LoadingAnnouncer from "../LoadingAnnouncer";

const ConfigurationPanel = () => {
	const { activeTab } = useTabs();
	const applicationsLoading = useStore(applicationsLoadingSelector);
	const marketsLoading = useStore(marketsLoadingSelector);
	const activeMarket = useStore(activeMarketSelector);
	const showConfiguration = React.useMemo(
		() => activeMarket && activeTab === HomePageLayoutTabs.Configuration,
		[activeMarket, activeTab]
	);

	const loading = React.useMemo(() => applicationsLoading || marketsLoading, [applicationsLoading, marketsLoading]);

	useLoadingAnnouncer("configurationPanel", loading);

	return (
		<>
			<LoadingAnnouncer loadingMessage="Loading configuration" completedMessage="Loading completed" />
			<h1>Configuration</h1>
			{loading ? (
				<LoadingComponent loadingText="Loading configuration" />
			) : showConfiguration ? (
				<ConfigurationViewer />
			) : !activeMarket ? (
				<LoadingWrapper>
					<InlineMessage
						title="No Configuration or Markets"
						body={"Seems like you don't any configuration or markets yet..."}
						variant="cautionary"
						headingLevel="2"
					/>
				</LoadingWrapper>
			) : null}
		</>
	);
};

export default ConfigurationPanel;
